import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {hasOneOfPermission, Permissions} from '../../../../store/reducers/user';
import React from 'react';
import MainScreenButton from '../../../../components/forms/mainScreenButton';

import {MainButtonBackground} from '../formsUtil';

function ClerkingButton(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const canSeeClerking = dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_VIEW_CLERKING, Permissions.AGYLE_CAN_MANAGE_CLERKING]));

    const clerkingDone = () => props.value?.who && props.value?.when;

    const clerkingButtonColor = () => clerkingDone() ? MainButtonBackground.GREEN : MainButtonBackground.RED;

    return (
        <MainScreenButton
            disabled={!canSeeClerking}
            onOpen={() => props.onClick(true)}
            label={t('ED Clerking')}
            filled={clerkingDone()}
            value={props.value}
            customColor
            btnBackground={clerkingButtonColor}
        />
    );
}

export default ClerkingButton;